<template>
  <section>
    <v-card
      class="my-4 top-space"
      outlined
      tile
      flat
    >
      <v-card-title>
        <div class="mr-auto">Other Products Review</div>
        <v-btn
          @click="previous()"
          icon
          x-small
          class="mx-2"
        >
          <v-icon color="primary">
            fal fa-edit
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <section class="opt-wrap">
          <v-row>
            <AccessoryDetails v-for="(product, key) in accessories" :key="key" v-bind="product" small />
          </v-row>
        </section>
      </v-card-text>
    </v-card>
  </section>
</template>

<style scoped lang="scss">
  .v-card__title {
    background-color: $gray-1;
    font-size: 16px;
    font-weight: 700;
    padding: 5px 0 5px 16px !important;

    @media screen and (min-width: 600px) {
      font-size: 20px;
    }
  }
  .v-card__text {
    padding: 10px 20px !important;

    @media screen and (min-width: 600px) {
      padding: 20px 40px !important;
    }

    .var-desc {
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
      margin-bottom: 0;

      @media screen and (min-width: 600px) {
        max-width: 70%;
      }
    }

    .no-bottom-pad {
      padding: 0 !important;
    }
  }

  .opt-wrap {
    margin: 20px 0;
    padding: 20px 0;
  }

  .col-pad {
    padding: 5px 12px 0;
  }

  .top-space {
    margin-top: 30px !important;
  }

  .prod-key {
    font-size: 16px;
    font-weight: 700;
    color: $text;
  }
  .var-desc {
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 0;

    @media screen and (min-width: 600px) {
      max-width: 70%;
    }
  }
</style>

<script>
  import { mapState, mapMutations } from 'vuex'
  import AccessoryDetails from './AccessoryDetails'

  export default {
    components: {
      AccessoryDetails
    },
    computed: {
      ...mapState([
        'accessories',
        'pricing',
      ])
    },
    methods: {
      ...mapMutations([
        'previous'
      ])
    }
  }
</script>